import { useRouter } from "vue-router";
import { useUserStore } from "@/stores/user";
import { useConfigStore } from "@/stores/config";

export function useAuth() {
  const router = useRouter();
  const userStore = useUserStore();
  const configStore = useConfigStore();

  const handleLogout = async (loginRouteName) => {
    if (!loginRouteName || typeof loginRouteName !== "string") {
      loginRouteName = "login";
    }
    if (configStore.AUTH === "keycloak" || configStore.AUTH === "lemonldap") {
      await userStore.logout();
    } else {
      await userStore.logout();
      router.push({ name: loginRouteName });
    }
  };

  return { handleLogout };
}
